import { useEffect, useState } from 'react';
import { Box, keyframes } from '@mui/material';

const sparkleAnimation = keyframes`
  0% {
    transform: scale(0) rotate(0deg);
    opacity: 1;
  }
  50% {
    transform: scale(1) rotate(180deg);
    opacity: 1;
  }
  100% {
    transform: scale(0) rotate(360deg);
    opacity: 0;
  }
`;

const Sparkle = ({
  color = '#ffd700',
  count = 8,
  size = 20,
  duration = 800,
  spread = 60,
  onComplete,
  trigger = true,
}) => {
  const [sparkles, setSparkles] = useState([]);

  useEffect(() => {
    if (!trigger) return;

    const newSparkles = Array.from({ length: count }).map((_, i) => {
      const angle = (i / count) * 360;
      const distance = spread * (0.5 + Math.random() * 0.5);
      const x = Math.cos((angle * Math.PI) / 180) * distance;
      const y = Math.sin((angle * Math.PI) / 180) * distance;
      const delay = Math.random() * 200;
      const sparkleSize = size * (0.6 + Math.random() * 0.4);

      return { id: i, x, y, delay, size: sparkleSize };
    });

    setSparkles(newSparkles);

    const timer = setTimeout(() => {
      setSparkles([]);
      onComplete?.();
    }, duration + 200);

    return () => clearTimeout(timer);
  }, [trigger, count, size, spread, duration, onComplete]);

  if (!trigger || sparkles.length === 0) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {sparkles.map((sparkle) => (
        <Box
          key={sparkle.id}
          sx={{
            position: 'absolute',
            width: sparkle.size,
            height: sparkle.size,
            transform: `translate(${sparkle.x}px, ${sparkle.y}px)`,
            animation: `${sparkleAnimation} ${duration}ms ease-out forwards`,
            animationDelay: `${sparkle.delay}ms`,
          }}
        >
          <svg viewBox="0 0 24 24" fill={color}>
            <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" />
          </svg>
        </Box>
      ))}
    </Box>
  );
};

export default Sparkle;
